import React, { useState } from "react";

import {
  CListGroup,
  CListGroupItem,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CCol,
  CProgress,
  CRow,
  CHeaderNavItem,
  CHeaderNavLink,
  CTooltip
} from "@coreui/react";
import { MdOutlineTask } from "react-icons/md";

import AlunoTurma from "../Statistics/Comparison/AlunoTurma";
import AssuntoAvaliacao from "../Statistics/Comparison/AssuntoAvaliacao";
import HistogramaAluno from "../Statistics/Comparison/HistogramaAluno";

import "./styles.css";

const EvaluationBankDashboardItem = props => {
  const [menu, setMenu] = useState("Estudante x Unidade");
  const [show, setShow] = useState(false);

  const onClose = () => {
    setShow(false);
  };

  const getMenus = () => [
    {
      name: "Estudante x Unidade",
      component: (
        <AlunoTurma activity_id={props.activityId} infoUser={props.infoUser} />
      )
    },
    {
      name: "Estudante x Habilidade",
      component: (
        <AssuntoAvaliacao
          activity_id={props.activityId}
          key="alunoassunto"
          infoUser={props.infoUser}
        />
      )
    },
    {
      name: "Histograma dos estudantes",
      component: (
        <HistogramaAluno
          activity_id={props.activityId}
          infoUser={props.infoUser}
        />
      )
    }
  ];

  return (
    <>
      <CModal
        size="lg w-100 h-100 m-0 p-2 mw-100"
        style={{ width: "100%", height: "100%" }}
        show={show}
        onClose={() => onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>Estatísticas da avaliação</CModalTitle>
        </CModalHeader>
        <CModalBody className="p-0 d-flex" style={{ overflow: "auto" }}>
          <CListGroup
            style={{
              height: "100%",
              backgroundColor:
                "#f6f8f9" /* , borderRight:"1px solid rgba(0, 0, 21, 0.125)" */
            }}
          >
            {getMenus()
              .filter(menuAux => !menuAux.hideMenu)
              .map(menuAux => (
                <CListGroupItem
                  action
                  active={menuAux.name === menu}
                  style={{ border: "0", borderRadius: "0", minWidth: "250px" }}
                  className="cursor"
                  onClick={() => setMenu(menuAux.name)}
                >
                  {menuAux.name}
                </CListGroupItem>
              ))}
          </CListGroup>
          <div
            // ref={state.printDiv}
            className="charts flex-1 d-flex justify-content-center"
            style={{ overflow: "auto" }}
          >
            <div className="mx-3 w-100">
              <div className="py-3 d-flex flex-column align-items-center container">
                <span className="est-text mb-3">
                  <h1>{menu}</h1>
                </span>
                {getMenus().find(menuAux => menuAux.name === menu).component}
              </div>
            </div>
          </div>
        </CModalBody>
      </CModal>

      <CRow className="evaluation-item-content d-flex align-items-center my-3 w-100">
        <CCol md="2" className="evaluation-item-image-content">
          <MdOutlineTask
            className="evaluation-item-image"
            style={{ color: "#02517C" }}
          />
        </CCol>
        <CCol
          sm="12"
          md="8"
          className="evaluation-item-main-content justify-items-start"
        >
          <h1 className="evaluation-item-tile">{props.title}</h1>
          <div className="d-flex w-100 align-items-center">
            <CProgress
              value={props.progress}
              className="evaluation-item-progressbar"
            />
            <p className="my-0 ml-2 text-bold">{`${props.progress}%`}</p>
          </div>
          <span className="evaluation-item-progressbar-description mb-2">
            Progresso geral
          </span>
        </CCol>
        <CCol sm="12" md="2" className="justify-items-end align-items-start">
          <div onClick={() => setShow(true)} style={{ cursor: "pointer" }}>
            <CTooltip content="Ver estatísticas do estudante">
              <CHeaderNavItem
                style={{
                  backgroundColor: "#CED2D7",
                  display: "flex",
                  justifyContent: "center",
                  padding: "15px 15px",
                  borderRadius: "10px"
                }}
              >
                <CHeaderNavLink to="#">
                  <id
                    style={{ color: "#02517C" }}
                    className="fa fa-bar-chart"
                  />
                </CHeaderNavLink>
              </CHeaderNavItem>
            </CTooltip>
          </div>
        </CCol>
      </CRow>
    </>
  );
};

export default EvaluationBankDashboardItem;
